import { ApiService } from "../..";

export const fetchUserList = (data: {
  role?: "admin" | "leader" | "member";
  cascade?: {
    role?: boolean;
    group?: boolean;
  };
  cascadeId?: boolean;
}) => {
  return ApiService.baseAction(
    "user/list",
    {
      data,
    },
    "post"
  );
};
